var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveLayerDownOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5.5v11M13.5 6.5l-5 5-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M15.5 15.5h-14"
  }))));
}
export default SvgMoveLayerDownOutline16;